import { Bullhorn, DataEnrichment, UserAvatar } from '@carbon/icons-react'
import MarketplaceIcon from 'app/(main)/_icons/MarketplaceIcon'
import ProjectsTbfIcon from 'app/(main)/_icons/ProjectsTbfIcon'
import type { ReactNode } from 'react'

export type NavItem = {
  title: string
  href: `/${string}`
  target?: '_self' | '_blank' | '_parent' | '_top'
  tag?: string
  icon?: ReactNode
}

export const NavItems: NavItem[] = [
  {
    title: 'Menschen',
    href: '/people/employees',
    icon: <UserAvatar aria-hidden />,
  },
  {
    title: 'Projekte',
    href: '/projects',
    icon: <ProjectsTbfIcon />,
  },
  {
    title: 'Wissen',
    href: '/stories',
    icon: <DataEnrichment aria-hidden />,
  },
  {
    title: 'Offerten',
    href: '/offers',
    icon: <Bullhorn aria-hidden />,
  },
  {
    title: 'Marktplatz',
    href: '/marketplace',
    icon: <MarketplaceIcon />,
  },
]
